export default __webpack_public_path__ + "static/media/file_upload_check.c083cbe8.svg";